import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "./lib/sentry";

// Initialise Sentry BEFORE React mounts so any error during initial
// render (including Suspense / lazy-load failures) is captured.
// No-op in dev unless REACT_APP_SENTRY_DSN_DEV=1.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
